var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container px-4 mx-auto"},[_c('div',{staticClass:"py-5 text-xs sm:text-sm bg-white border-solid sm:text-center text-blck montserrat-reg"},[_c('p',{staticClass:"lg:mb-5 lg:leading-none"},[_vm._v(" Website maintained by Activa Media. "),_c('span',{staticClass:"inline-block"},[_vm._v("All rights reserved.")])])])])
}]

export { render, staticRenderFns }